import { useState, useEffect } from 'react'
import Outlined from '../div/Outlined'
import Footer from '../footer/Footer'
import Listing from '../listing/Listing'
import Navbar from '../navbar/Navbar'
import PropList from '../proplist/PropList'
import axios from 'axios'
import {Link} from 'react-router-dom'
import './otherprops.css'
import{motorProps,
FurnitureProps,
electroProps,
landProps
} from './data'
import { axiosInstance } from '../../config'

function OtherProps() {
    const [selected, setSelected] = useState('furnitures')
    const [lists, setLists] = useState([])
    const [data, setData] = useState([])
    useEffect(() => {
    const getListData = async() => {
    try {
        const res =  await axiosInstance.get('/api/list');
    setLists(res.data)
    } catch (err) {
      console.log(err)  
    }
    }
    getListData();
    });
    const list = [
       
        {
            id:'furnitures',
            title:'Funitures'
        },
        {
            id:'electronics',
            title:'Electronics'
        },
        
        {
            id:'motors',
            title:'Motors'
        },
        {
            id:'lands',
            title:'Lands'
        },

    ];

    

    useEffect(() =>{
      switch(selected){
              case "furnitures":
              setData(FurnitureProps);
              break;
              case "electronics":
              setData(electroProps);
              break;
              case "motors":
              setData(motorProps);
              break;
               case "lands":
              setData(landProps);
              break;
              default:
                  setData(FurnitureProps)
      }
    },[selected])


    return (
        <div className='other--props'>
            <Navbar/>
            <div className="other--props-wrapper">
                <h1>Our other properties</h1>
                <Outlined/>
                <ul>
                   {list.map((item) => (
                       <PropList title={item.title}
                        active={selected === item.id}
                        id={item.id}
                        setSelected={setSelected}/>
                   ))}
                </ul>
                <div className='other--props--container'>
                {
                    data.map((d) => (
                          <div className='single--props'>
                        <img className='props--Image' src={d.img} alt=''/>
                        <div className='props-details'>
                            <p><b>Cost:</b> ${d.cost}</p>
                          <Link to='/pay' className='link'><button><span>Buy Now</span></button></Link>  
                        </div>
                    </div>
                    ))
                }
                </div>

                <div className='listing--container'>
                    <h1>We help you list your property</h1>
                     <Outlined/>
                <div className='listing--Items'>
                    {lists.map(list => (
                        <Listing lists={list} selected={selected}/>
                    ))}
                </div>
                </div>
                
            </div>
            <Footer/>
        </div>
    )
}

export default OtherProps
